import { useState } from "react";
import { Alert, Button, Paper, Stack, TextField, MenuItem, Typography } from "@mui/material";
import { apiRequest } from "../utils/http";

const empty = { key: null, name: "", active: true, displayOrder: 100 };
export default function CategoryManager({ categories, onSaved, endpoint = "/api/admin/categories", title = "Product categories", description = "Categories are shared by both websites and the Inventory PDF. Rename without changing product assignments or bookmark keys. Reassign products before deactivation; categories cannot be deleted." }) {
  const [form, setForm] = useState(empty);
  const [error, setError] = useState(""), [saving, setSaving] = useState(false);
  async function save(event) {
    event.preventDefault(); setSaving(true); setError("");
    try {
      await apiRequest(`${endpoint}${form.key ? `/${encodeURIComponent(form.key)}` : ""}`, {
        method: form.key ? "PUT" : "POST",
        body: JSON.stringify({ name: form.name, active: form.active, displayOrder: Number(form.displayOrder) })
      });
      await onSaved(); setForm(empty);
    } catch (e) { setError(e.message); } finally { setSaving(false); }
  }
  return <Paper component="section" sx={{ p: { xs: 2, md: 3 } }}>
      <Typography variant="h5">{title}</Typography>
        <Alert severity="info">{description}</Alert>
        {error && <Alert severity="error">{error}</Alert>}
        <Stack component="form" onSubmit={save} spacing={2} sx={{ my: 3 }}>
          <Typography variant="h6">{form.key ? "Edit category" : "Create category"}</Typography>
          <TextField label="Category name" required value={form.name} inputProps={{ maxLength: 80 }} onChange={e => setForm({ ...form, name: e.target.value })} />
          <TextField label="Display order" type="number" required inputProps={{ min: 0, max: 100000, step: 1 }} value={form.displayOrder} onChange={e => setForm({ ...form, displayOrder: e.target.value })} />
          <TextField select label="Category visibility" value={String(form.active)} onChange={e => setForm({ ...form, active: e.target.value === "true" })}>
            <MenuItem value="true">Active</MenuItem><MenuItem value="false">Inactive</MenuItem>
          </TextField>
          <Button type="submit" disabled={saving} variant="contained">Save category</Button>
          {form.key && <Button disabled={saving} onClick={() => setForm(empty)}>Cancel editing</Button>}
        </Stack>
        <Typography variant="h6">Current categories</Typography>
        {!categories.length && <Typography>No categories in this scope yet.</Typography>}
        <Stack spacing={1}>{categories.map(category => <Stack key={category.key} direction="row" alignItems="center" justifyContent="space-between">
          <Typography>{category.name} ({category.active ? "Active" : "Inactive"}; order {category.displayOrder}){category.legacy ? " - existing product value" : ""}</Typography>
          <Button disabled={saving} onClick={() => { setForm(category); setError(""); }} aria-label={`Edit category ${category.name}`}>Edit</Button>
        </Stack>)}</Stack>
  </Paper>;
}
